import { useTeamConfig } from "../components/TeamConfigProvider";

export function TeamAnalyticsHeader() {
  const { TEAM_GLOBAL_SETTINGS } = useTeamConfig();
  return (
    <>
      {TEAM_GLOBAL_SETTINGS?.ANALYTICS_HEADER ? (
        <TEAM_GLOBAL_SETTINGS.ANALYTICS_HEADER />
      ) : null}
    </>
  );
}
